import { render, staticRenderFns } from "./MailDN.vue?vue&type=template&id=4d29788b&scoped=true"
import script from "./MailDN.vue?vue&type=script&lang=js"
export * from "./MailDN.vue?vue&type=script&lang=js"
import style0 from "./MailDN.vue?vue&type=style&index=0&id=4d29788b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d29788b",
  null
  
)

export default component.exports